import { DictionariesService } from "@sa/rep-mdm";
import { uniq } from "../../../../../shared";

export async function getDefaultMark(dictionariesService: DictionariesService) {
  const calendarDict = await dictionariesService.getDictionary({
    id: 'slides-calendar-slide17',
    parameters: {},
  });
  const calendarItems = await calendarDict.getAll();
  const calendar = uniq(calendarItems.map(item => Number(item.id)));
  return { calendar };
}